export const COLD_WEATHER_BATTERY_VERSION = '41067-BSS-001';
